/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import store from "store";
import { useAuth } from "./context/auth.context";
import { list as listProjects } from "services/apis/scadaProject";
import { isScadaRuntimeRoute, isScadaSimulationRoute } from "pages/scadaDesigner/runtimeEmbedding";

function ProjectBoundary({ permission, routeProps, Component }) {
  const user = store.get("user");
  const [allowed, setAllowed] = useState(user?.role === "admin" ? true : null);
  const projectId = routeProps.match.params.projectId || routeProps.match.params.id;

  useEffect(() => {
    if (user?.role === "admin" || !permission) return undefined;
    let active = true;
    listProjects().then((response) => {
      if (!active) return;
      const project = (response?.items || []).find((item) => String(item.id) === String(projectId));
      setAllowed(Boolean(project && (permission !== "design" || project.canDesign)));
    }).catch(() => active && setAllowed(false));
    return () => { active = false; };
  }, [permission, projectId, user?.role]);

  if (allowed === null) {
    const runtimeScreen = isScadaRuntimeRoute(routeProps.location.pathname) ||
      isScadaSimulationRoute(routeProps.location.pathname);
    return runtimeScreen
      ? <div style={{ display: "flex", justifyContent: "center", padding: 40, color: "#64748b" }}>Opening Screen...</div>
      : <div style={{ display: "flex", justifyContent: "center", padding: 40 }}><CircularProgress size="1.5rem" /></div>;
  }
  return allowed ? <Component {...routeProps} /> : <Redirect to="/404" />;
}

ProjectBoundary.propTypes = { permission: PropTypes.string, routeProps: PropTypes.object.isRequired, Component: PropTypes.elementType.isRequired };

export const ProtectedRoute = ({ roles, component: Component, projectPermission, selfOrAdmin, ...rest }) => {
  const loggedUser = store.get("user");
  const { user } = useAuth();
  if (!user?.token) return <Redirect to="/login" />;
  if (!loggedUser || !roles.includes(loggedUser.role)) return <Redirect to="/404" />;

  return <Route {...rest} render={(props) => {
    if (selfOrAdmin && loggedUser.role !== "admin" && String(props.match.params.id) !== String(loggedUser.id)) return <Redirect to="/404" />;
    if (projectPermission) return <ProjectBoundary permission={projectPermission} routeProps={props} Component={Component} />;
    return <Component {...props} />;
  }} />;
};

ProtectedRoute.propTypes = {
  roles: PropTypes.array.isRequired,
  component: PropTypes.elementType.isRequired,
  projectPermission: PropTypes.string,
  selfOrAdmin: PropTypes.bool,
};
